import CompensationProfileForm from "@/components/Forms/CompensationProfileForm";
import MultiStepFormSkeleton from "@/components/Skeleton/MultiStepFormSkeleton";
import { useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { GET_COMPENSATION_PROFILES_QUERY } from "../../queries";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import { getInitialTotalCompensationProfile } from "@/components/Forms/CompensationProfileForm/initialTotalCompensationProfile";

export default function EditCompensationProfilePage() {
  useRequireCapability({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.manageCompensationProfiles
  });

  const { pgaId, compProfileId } = useParams();
  const navigate = useNavigate();

  const { data: compProfile, loading: compProfileLoading } = useQuery(GET_COMPENSATION_PROFILES_QUERY, {
    variables: {
      pgaId: pgaId
    }
  });

  if (compProfileLoading) {
    return <MultiStepFormSkeleton stepCount={5} renderStepper={true} />;
  }

  const compensationProfiles = compProfile?.person?.compensationProfiles ?? [];
  const defaultValues = compensationProfiles.find((profile: any) => profile.id === compProfileId);
  const initialTotalCompensationProfile = getInitialTotalCompensationProfile(compensationProfiles);

  return (
    <CompensationProfileForm
      onSubmit={() => navigate(`/people/${pgaId}/career/compensation/${compProfileId}/view`)}
      isEdit
      defaultValues={defaultValues}
      pgaId={pgaId}
      contactId={compProfile?.person?.id}
      includeInitialTotalCompensation={defaultValues?.id === initialTotalCompensationProfile?.id}
    />
  );
}
